import { inject, Injectable } from '@angular/core';

import { GoogleTagManagerConfig } from './google-tag-manager-config';
import { GOOGLE_TAG_MANAGER_CONFIG } from './google-tag-manager.tokens';

// adapted from https://github.com/auth0/auth0-angular#dynamic-configuration
@Injectable({ providedIn: 'root' })
export class DpGoogleTagManagerConfiguration {
  #googleTagManagerConfig: GoogleTagManagerConfig = inject(GOOGLE_TAG_MANAGER_CONFIG, { optional: true }) || {
    id: null,
    gtm_auth: '',
    gtm_preview: '',
  };

  constructor() {
    if (this.#googleTagManagerConfig) {
      this.set(this.#googleTagManagerConfig);
    }
  }

  public set(googleTagManagerConfig: GoogleTagManagerConfig): void {
    this.#googleTagManagerConfig = googleTagManagerConfig;
  }

  public get(): GoogleTagManagerConfig {
    return this.#googleTagManagerConfig;
  }
}
